import React from 'react';
import colours from 'styles/colours';
import {Link} from 'react-router-dom';

export default function FooterLink(props) {

    const {href, children} = props;

    const [isHovered, setIsHovered] = React.useState(false);

    const style = {
        color: colours.font.main,
        textDecoration: isHovered ? 'underline' : 'none',
        padding: '3px',
        margin: '0 8px',
    };

    return (
        <Link 
            style={style} 
            to={href} 
            target="_blank" 
            rel="noopener noreferrer"
            onMouseEnter={() => setIsHovered(true)}
            onMouseLeave={() => setIsHovered(false)}
            onFocus={() => setIsHovered(true)}
            onBlur={() => setIsHovered(false)}
        >
            {children}
        </Link>
    );

}